import i18n from "i18next";
import {
    initReactI18next
} from "react-i18next";




i18n
    .use(initReactI18next)
    .init({
        resources: {
            lat: {
                translation: {
                    "pksLogoUrl": "./images/pks-logotip.png",
                    "glavniNaslov": "NACIONALNA NAGRADA ZA DRUŠTVENO ODGOVORNO POSLOVANjE ĐORĐE VAJFERT 2022",
                    "pasus1-1": "Privredna komora Srbije Vas poziva da uzmete učešće na konkursu za ",
                    "pasus1-2": '"Nacionalnu nagradu za društveno odgovorno poslovanje Đorđe Vajfert 2022", ',
                    "pasus1-3": "koji organizuje deveti put u cilju promovisanja i uspostavljanja principa i prakse društveno odgovornog poslovanja (DOP) u Republici Srbiji.",
                    "podnsalov2": "Ko može da konkuriše?",
                    "pasus2": "Sve kompanije i organizacije  koje primenjuju principe rada zasnovane na etičkim, ekonomskim, socijalnim i normama kojima se štiti i unapređuje životna sredina mogu se prijaviti na konkurs. Neophodno je da je kompanija realizovala društveno odgovorni projekat u prethodne dve godine (ili je započet, ali sa već vidljivim i merljivim rezultatima). Radi bližih informacija koji projekti će biti bolje vrednovani pogledajte dokument Smernice za pripremu DOP projekta.",
                    "podnsalov3": "Ocenjivanje prijava",
                    "pasus3": "Kandidati na konkursu će biti rangirani u skladu sa unapred definisanom metodologijom i kriterijumima, što obuhvata i pisane izveštaje tima Privredne komore Srbije o nivou primene principa DOP-a u praksi. Finalnu evaluaciju obavlja stručni žiri, sastavljen od predstavnika državnih institucija, privredne asocijacije, nevladine organizacije i medija, a koji će svojim glasanjem odlučiti o nagradama.",
                    "podnaslov3A":"Koje kategorije nagrade se dodeljuju?",
                    "pasus3A":"Nagrada se dodeljuje u tri kategorije: Velika privredna društva, Srednja privredna društva, Mala i mikro privredna društva. U skladu sa dostavljenim prijavama, interni Tim može dodatno odlučiti o uručivanju posebnih priznanja za odredjene oblasti društveno odgovornog poslovanja (poput: podrška mladima, poslovanje po meri porodice, pomoć ugroženim grupama stanovništva, doprinos unapredjenju zaštite životne sredine, razvoj kulture i sl).",
                    "podnsalov4": "Rokovi",
                    "pasus4-1": "Rok za prijave na Deveti konkurs „Nacionalne nagrade za društveno odgovorno poslovanje Djordje Vajfert 2022“  ",
                    "pasus4-2": " produžen je do 10.01.2023. godine. ",
                    "pasus4-3": "Upitnik neophodan za prijavu, možete pronaći ",
                    "pasus4-4": "ovde.",
                    "nazivKompanije": "Naziv kompanije",
                    "maticniBroj": "Matični broj",
                    "kontaktOsoba": "Kontakt osoba",
                    "pozicijaUkompaniji": "Pozicija u kompaniji",
                    "email": "E-pošta",
                    "telefon": "Telefon",
                    "upitnikTekst": "Molimo vas pošaljite nam popunjen",
                    "upitnik": "UPITNIK",
                    "ostalaDokumenta1": "Pridružite ostala dokumenta",
                    "ostalaDokumenta2": "(limit za svaki pojedinačno je 15MB)",
                    "dokumenta": "Dokumenta za preuzimanje:",
                    "upitnikZaPrivrednaDrustva": "Upitnik za privredna društva",
                    "rokovi2022": "Rokovi 2022",
                    "smerniceZaPripremuDOPprojekata": "Smernice za pripremu DOP projekta",
                    "metodologija": "Metodologija dodele nagrade",
                    "primeriDobrePrakse": "Primeri dobre prakse nagrade DOP 2018-2020",
                    "obaveznoPolje": "*Obavezno polje",
                    "fajlSize15mb": "Ogranicenje za slanja fajla je do 15MB",
                    "brFajlovaOgranicenje": "Molimo vas da pošaljete do 5 dokumenata",
                    "saglasnost1": "Potvrđujem tačnost unetih podataka",
                    "saglasnost2": "Saglasan sa obradom podataka o ličnosti",
                    "posalji": "Pošalji",
                    "slanjeUtoku": "Slanje u toku...",
                    "succes1": "Uspešno ste podneli prijavu.",
                    "succes2": "Ukoliko su vam potrebne dodatne informacije kontaktirajte nas na ",
                    "succesBtn": "Nazad na glavni sajt",
                    "pksFooterLogo": "https://pks.rs//images/logo-white_lat@3x.png",
                    "sanjaBunic": "Sanja Bunić",
                    "sanjaBunicTitle": "Viši savetnik za društveno odgovorno poslovanje",
                    "milenaMilisavljevic": "Milena Milisavljević",
                    "milenaMilisavljevicTitle": "Viši savetnik za kvalitet",
                    "zastitaPodataka":"Politika zaštite podataka o ličnosti",
                    "pozivnoPismo": "Pozivno pismo",
                    "pravilnikOdodeli":"Pravilnik o dodeli nagrade"
                }
            },
            cyr: {
                translation: {
                    "pksLogoUrl": "./images/pks-logotip-cyr.png",
                    "glavniNaslov": "НАЦИОНАЛНА НАГРАДА ЗА ДРУШТВЕНО ОДГОВОРНО ПОСЛОВАЊЕ ЂОРЂЕ ВАЈФЕРТ 2022",
                    "pasus1-1": "Привредна комора Србије Вас позива да узмете учешће на конкурсу за ",
                    "pasus1-2": '"Националну награду за друштвено одговорно пословање Ђорђе Вајферт 2022", ',
                    "pasus1-3": "који организује девети пут у циљу промовисања и успостављања принципа и праксе друштвено одговорног пословања (ДОП) у Републици Србији.",
                    "podnsalov2": "Ко може да конкурише?",
                    "pasus2": "Све компаније и организације које примењују принципе рада засноване на етичким, економским, социјалним и нормама којима се штити и унапређује животна средина могу се пријавити на конкурс. Неопходно је да је компанија реализовала друштвено одговорни пројекат у претходне две године (или је започет, али са већ видљивим и мерљивим резултатима). Ради ближих информација који пројекти ће бити боље вредновани погледајте документ Смернице за припрему ДОП пројекта.",
                    "podnsalov3": "Оцењивање пријава",
                    "pasus3": "Кандидати на конкурсу ће бити рангирани у складу са унапред дефинисаном методологијом и критеријумима, што обухвата и писане извештаје тима Привредне коморе Србије о нивоу примене принципа ДОП-а у пракси. Финалну евалуацију обавља стручни жири, састављен од представника државних институција, привредне асоцијације, невладине организације и медија, а који ће својим гласањем одлучити о наградама.",
                    "podnaslov3A":"Које категорије награде се додељују?",
                    "pasus3A":"Награда се додељује у три категорије: Велика привредна друштва, Средња привредна друштва, Мала и микро привредна друштва. У складу са достављеним пријавама, интерни Тим може додатно одлучити о уручивању посебних признања за одређене области друштвено одговорног пословања (попут: подршка младима, пословање по мери породице, помоћ угроженим групама становништва, допринос унапређењу заштите животне средине, развој културе и сл).",
                    "podnsalov4": "Рокови",
                    "pasus4-1": "Рок за пријаве на Девети конкурс „Националне награде за друштвено одговорно пословање Ђорђе Вајферт 2022“   ",
                    "pasus4-2": " продужен је до 10.01.2023. године. ",
                    "pasus4-3": "Упитник неопходан за пријаву, можете пронаћи ",
                    "pasus4-4": "овде.",
                    "nazivKompanije": "Назив компаније",
                    "maticniBroj": "Матични број",
                    "kontaktOsoba": "Контакт особа",
                    "pozicijaUkompaniji": "Позиција у компанији",
                    "email": "Е-пошта",
                    "telefon": "Телефон",
                    "upitnikTekst": "Молимо вас пошаљите нам попуњен",
                    "upitnik": "УПИТНИК",
                    "ostalaDokumenta1": "Придружите остала документа",
                    "ostalaDokumenta2": "(лимит за сваки појединачно је 15МБ)",
                    "dokumenta": "Документа за преузимање:",
                    "upitnikZaPrivrednaDrustva": "Упитник за привредна друштва",
                    "rokovi2022": "Рокови 2022",
                    "smerniceZaPripremuDOPprojekata": "Смернице за припрему ДОП пројекта",
                    "metodologija": "Методологија доделе награде",
                    "primeriDobrePrakse": "Примери добре праксе награде ДОП 2018-2020",
                    "obaveznoPolje": "*Обавезно поље",
                    "fajlSize15mb": "Ограничење за слање фајла је до 15МБ",
                    "brFajlovaOgranicenje": "Молимо вас да пошаљете до 5 докумената",
                    "saglasnost1": "Потврђујем тачност унетих података",
                    "saglasnost2": "Сагласан са обрадом података о личности",
                    "posalji": "Пошаљи",
                    "slanjeUtoku": "Слање у току...",
                    "succes1": "Успешно сте поднели пријаву.",
                    "succes2": "Уколико су вам потребне додатне информације контактирајте нас на ",
                    "succesBtn": "Назад на главни сајт",
                    "pksFooterLogo": "https://pks.rs/images//images/logo-white_cir@3x.png",
                    "sanjaBunic": "Сања Бунић",
                    "sanjaBunicTitle": "Виши саветник за друштвено одговорно пословање",
                    "milenaMilisavljevic": "Милена Милисављевић",
                    "milenaMilisavljevicTitle": "Виши саветник за квалитет",
                    "zastitaPodataka":"Политика заштите података о личности",
                    "pozivnoPismo": "Позивно писмо",
                    "pravilnikOdodeli":"Правилник о додели награде"
                }
            }
        },
        lng: "cyr",
        fallbackLng: "cyr",
        interpolation: {
            escapeValue: false
        }
    })

export default i18n